export default {
    'searchList': {
        'searchTxt': [{
            'name': '运输单号',
            'value': 'mddrTaskNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '发车单号',
            'value': 'mddrDoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 30,
            'unfold': true,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '运输单号',
                'prop': 'mddrTaskNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车单号',
                'prop': 'mddrDoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '合同编号',
                'prop': 'ettaContractNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '移交单号',
                'prop': 'mddlEttdNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '移交单状态',
                'prop': 'mddlStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户订单号',
                'prop': 'mddrCustomerOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'mddrCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '线路',
                'prop': 'mddrLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '签收时间',
                'prop': 'mddrTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '签收人',
                'prop': 'mddrContact',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否完好',
                'prop': 'mddrIsFullType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '直通宝标识',
                'prop': 'ztbzcldType',
                'sort': true,
                'width': '148px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '打印',
                'size': 'mini',
                'event': 'print',
                'ifHas': '05050202'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '客户订单号',
            'value': 'mddrCustomerOrderNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '合同号',
            'value': 'ettaContractNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#pmCode', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '移交单状态',
            'value': 'mddlStatus',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TMS_TANSFER_STATUS',
            'multiple': false
        }, {
            'name': '物流订单号',
            'value': 'mddrLogisticsOrderNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '直通宝标识',
            'value': 'ztbzcld',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TMS_ZTB_FLAG',
            'multiple': false
        }
    ]
};
